module.exports = __webpack_public_path__ + "img/content-6.23c8aec5.png";